module.exports = __webpack_public_path__ + "img/guozai_11.641879bd.jpg";